import styled from 'styled-components';

const FlexHeaderNoSpace = styled.div`
   display: flex;
`;

export default FlexHeaderNoSpace;